<div class="user-data">
  <div class="welcome-block">
    <span class="name">{{ name }}</span>
    <span class="settings">
      @if (isAdmin) {
        <span class="tab" (click)="gotoAdmin()">Admin</span>
      }
      @if (isAdmin) {
        <span class="divider">|</span>
      }
      <span class="tab" (click)="gotoAccount()">Account</span>
      <span class="divider">|</span>
      <!--<span class="tab" (click)="gotoTools()">Tools</span>
      <span class="divider">|</span>-->
      <span class="tab" (click)="logout()">Logout</span>
      <!--<span class="divider">|</span>
      <a href="/documentation/PDF/UVexplorerServer2.0Documentation.pdf" class="tab" target="_blank">Docs</a>-->
    </span>
  </div>
</div>
